<script>
export default {
    page() {
        const title = 'FRISKY — Underground Electronic Music Radio & DJ Mixes'
        const description = 'Stream curated DJ mixes, live shows, and underground electronic music — house, techno, progressive, and more — on FRISKY since 2002.'
        const image = `${import.meta.env.VITE_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = 'https://frisky.fm/'
        return {
            title,
            titleTemplate: '%s',
            link: [
                { rel: 'canonical', vmid: 'canonical', href: canonicalUrl },
            ],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
}
</script>

<script setup>
import { computed } from 'vue'
import { useStore } from '@composables/use-store'
import Layout from '@layouts/main-layout'
import HomeUnAuth from '@router/views/homepage/homepage-unauth'
import HomeAuth from '@router/views/homepage/homepage-auth'

const store = useStore()

const loggedIn = computed(() => store.getters['auth/loggedIn'])
</script>

<template>
    <Layout>
        <BaseContent class="content">
            <HomeAuth v-if="loggedIn" />
            <HomeUnAuth v-else />
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
